/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/Assets";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _offcanvas = __webpack_require__(2);
	
	var _offcanvas2 = _interopRequireDefault(_offcanvas);
	
	var _navigation = __webpack_require__(3);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _pushNavigation = __webpack_require__(4);
	
	var _pushNavigation2 = _interopRequireDefault(_pushNavigation);
	
	var _jqueryEvent = __webpack_require__(6);
	
	var _jqueryEvent2 = _interopRequireDefault(_jqueryEvent);
	
	var _slider = __webpack_require__(7);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _accordion = __webpack_require__(9);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _collapse = __webpack_require__(10);
	
	var _collapse2 = _interopRequireDefault(_collapse);
	
	var _platform = __webpack_require__(12);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	var _map = __webpack_require__(13);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _search = __webpack_require__(14);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _blog = __webpack_require__(15);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _hackyFixes = __webpack_require__(16);
	
	var _hackyFixes2 = _interopRequireDefault(_hackyFixes);
	
	var _tifigsPommfritt = __webpack_require__(17);
	
	var _tifigsPommfritt2 = _interopRequireDefault(_tifigsPommfritt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import inputs from 'modules/inputs';
	
	
	(0, _jquery2.default)(function () {
	  (0, _platform2.default)();
	  (0, _offcanvas2.default)();
	  (0, _navigation2.default)();
	  (0, _pushNavigation2.default)();
	  (0, _slider2.default)();
	  (0, _accordion2.default)();
	  (0, _collapse2.default)();
	  (0, _tifigsPommfritt2.default)();
	  //search();
	  //inputs();
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  (0, _jquery2.default)('.offcanvas__toggler').on('click', function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)('html').toggleClass('offcanvas--open');
	  });
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var $lis = (0, _jquery2.default)('.default > .navigation__list > li');
	
	  (0, _jquery2.default)(".navigation__level:not(.default)").each(function () {
	    var ref = (0, _jquery2.default)(this);
	    var title = ref.parent().find("a").html();
	    ref.attr("data-title", title);
	  });
	
	  var open = function open(event) {
	    var $target = (0, _jquery2.default)(event.currentTarget);
	    $target.siblings().removeClass('hover');
	    $target.addClass('hover');
	  };
	
	  var close = function close(event) {
	    var $target = (0, _jquery2.default)(event.currentTarget);
	    $target.removeClass('hover');
	  };
	
	  var closeAll = function closeAll() {
	    $lis.removeClass('hover');
	  };
	
	  var handleTouch = function handleTouch(event) {
	    // Prevent artificial click events
	    var $target = (0, _jquery2.default)(event.currentTarget);
	    event.stopPropagation();
	    if (!$target.hasClass('hover')) {
	      event.preventDefault();
	      $target.mouseenter();
	    }
	  };
	
	  var hasTouchend = 'ontouchend' in window;
	  if (hasTouchend) {
	    (0, _jquery2.default)('body').on('touchend', closeAll);
	    $lis.on('touchend', handleTouch);
	  }
	
	  $lis.on('mouseenter', open);
	  $lis.on('mouseleave', close);
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var $pushMenu = (0, _jquery2.default)('.navigation');
	  var $deeper = $pushMenu.find('.deeper');
	  var $back = $pushMenu.find('.back');
	  var $levels = $pushMenu.find('.navigation__level:not(.default)');
	
	  /**
	   * Slide in the next deeper level
	   * @param  {object} e Event object
	   * @return {undefined}
	   */
	  var slideIn = function slideIn(e) {
	
	    // Only prevent default and add classes on mobile
	    if (!core.isMobileView()) return;
	
	    e.preventDefault();
	
	    // Find next level
	    var $target = (0, _jquery2.default)(e.currentTarget); // .deeper
	    var $levelToFade = $target.closest('.navigation__level'); // .level
	    var $levelToSlideIn = $target.closest('li').children('.navigation__level'); // .level
	
	    $levelToSlideIn.addClass('in');
	    $levelToFade.addClass('cover display-cover'); // Display cover to distinguish levels
	  };
	
	  /**
	   * Slide back to the upper level
	   * @param  {object} e Event object
	   * @return {undefined}
	   */
	  var slideOut = function slideOut(e) {
	    // Only prevent default and add classes on mobile
	    if (!core.isMobileView()) return;
	
	    // Don't propagate swipe event, otherwise offcanvas
	    // would close on every swipe
	    e.preventDefault();
	    e.stopPropagation();
	
	    // Target is either the level itself (swipe) or the back button,
	    // so we have to find the $level with different strategies in each case
	    var $target = (0, _jquery2.default)(e.currentTarget); // .back
	    var $levelToSlideOut = $target.closest('.navigation__level');
	    var $levelToReveal = $levelToSlideOut.parent().closest('.navigation__level');
	
	    // Make it go away
	    $levelToSlideOut.removeClass('in');
	
	    // Display the cover to visually distinguish the levels
	    $levelToReveal.removeClass('cover');
	
	    // Compatibility mode fallback, trigger event instantly
	    if (core.getTransitionEndString() === 'transitionEndFallback') {
	      $levelToReveal.trigger(core.getTransitionEndString());
	    }
	
	    /**
	     * Hide the cover. If transitionend is not fired by
	     * opacity, re-bind the event once and wait for opacity
	     * to fire.
	     * @param  {Object} e jQuery event object
	     * @return {undefined}
	     */
	    var slideOut_transitionend = function slideOut_transitionend(e) {
	      e.stopPropagation();
	      var $target = (0, _jquery2.default)(e.currentTarget);
	
	      if (e.originalEvent.propertyName !== 'opacity') {
	        $target.one(core.getTransitionEndString(), slideOut_transitionend);
	        return;
	      }
	
	      $target.removeClass('display-cover');
	    };
	
	    // Remove cover only when transition has ended
	    $levelToReveal.one(core.getTransitionEndString(), slideOut_transitionend);
	  };
	
	  // Register events
	  $deeper.on('click touchend', slideIn);
	  $back.on('click', slideOut);
	  $levels.on('swipeleft', slideOut);
	
	  // Prevent transitionend events on deeper links
	  // from bubbling to .level
	  $deeper.on(core.getTransitionEndString(), function (e) {
	    e.stopPropagation();
	  });
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _core = __webpack_require__(5);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	 * Check for touch events (detects IE Tablet with Windows RT)
	 * This function return true in the case is a:
	 * - pc touchscreen enabled in mode not mobile
	 * @return {Boolean} Is the website displayed on a touch enabled screen?
	 */
	var isTouch = exports.isTouch = function isTouch() {
		return 'ontouchstart' in window;
	};
	
	/**
	 * See if it is one of microsoft f***** up tablet/laptop anomalies.
	 * @return {Boolean} [description]
	 */
	var isWindowsTouch = exports.isWindowsTouch = function isWindowsTouch() {
		if (navigator.msMaxTouchPoints !== undefined) {
			if (navigator.msMaxTouchPoints === 0) {
				return false;
			}
		}
	
		return 'onmouseenter' in window && 'msMaxTouchPoints' in navigator;
	};
	
	var isIE = exports.isIE = function isIE() {
		var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		if (isNaN(msie)) {
			msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		}
		return msie;
	};
	
	/**
	 * Get the correctly prefixed transitionend event string
	 * @return {string} Transitionend event name
	 */
	var getTransitionEndString = exports.getTransitionEndString = function getTransitionEndString() {
		var i = void 0,
		    undefined = void 0,
		    el = document.createElement('div'),
		    transitions = {
			transition: 'transitionend',
			OTransition: 'otransitionend', // oTransitionEnd in very old Opera
			MozTransition: 'transitionend',
			WebkitTransition: 'webkitTransitionEnd'
		};
	
		for (i in transitions) {
			if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
				return transitions[i];
			}
		}
	
		// Return a fallback for browsers who don't know transitions
		return 'transitionEndFallback';
	};
	
	/**
	 * Check if window width is below mobile threshhold
	 * @return {Boolean} True if mobile, false if above or equal 768
	 */
	var isMobileView = exports.isMobileView = function isMobileView() {
		return window.innerWidth < 992;
	};
	
	var device = 'large'; // 1920 <=      px
	var desktop = 1920; // 1200 -  1919 px
	var laptop = 1200; //  992 -  1199 px
	var tablet = 992; //  768 -   991 px
	var mobile = 768; //    0 -   767 px
	
	/**
	 * Get a string representing current viewport width
	 * @return {string} Viewport width category
	 */
	var getViewport = exports.getViewport = function getViewport() {
		var width = window.innerWidth;
	
		if (width < desktop) device = 'desktop';
		if (width < laptop) device = 'laptop';
		if (width < tablet) device = 'tablet';
		if (width < mobile) device = 'mobile';
	
		return device;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// jQuery.event.swipe
	// 0.5
	// Stephen Band
	
	// Dependencies
	// jQuery.event.move 1.2
	
	// One of swipeleft, swiperight, swipeup or swipedown is triggered on
	// moveend, when the move has covered a threshold ratio of the dimension
	// of the target node, or has gone really fast. Threshold and velocity
	// sensitivity changed with:
	//
	// jQuery.event.special.swipe.settings.threshold
	// jQuery.event.special.swipe.settings.sensitivity
	
	(function (thisModule) {
		if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (thisModule), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module !== "undefined" && module !== null) && module.exports) {
	        module.exports = thisModule;
		} else {
			// Browser globals
	        thisModule(jQuery);
		}
	})(function(jQuery, undefined){
		var add = jQuery.event.add,
		   
		    remove = jQuery.event.remove,
	
		    // Just sugar, so we can have arguments in the same order as
		    // add and remove.
		    trigger = function(node, type, data) {
		    	jQuery.event.trigger(type, data, node);
		    },
	
		    settings = {
		    	// Ratio of distance over target finger must travel to be
		    	// considered a swipe.
		    	threshold: 0.4,
		    	// Faster fingers can travel shorter distances to be considered
		    	// swipes. 'sensitivity' controls how much. Bigger is shorter.
		    	sensitivity: 6
		    };
	
		function moveend(e) {
			var w, h, event;
	
			w = e.currentTarget.offsetWidth;
			h = e.currentTarget.offsetHeight;
	
			// Copy over some useful properties from the move event
			event = {
				distX: e.distX,
				distY: e.distY,
				velocityX: e.velocityX,
				velocityY: e.velocityY,
				finger: e.finger
			};
	
			// Find out which of the four directions was swiped
			if (e.distX > e.distY) {
				if (e.distX > -e.distY) {
					if (e.distX/w > settings.threshold || e.velocityX * e.distX/w * settings.sensitivity > 1) {
						event.type = 'swiperight';
						trigger(e.currentTarget, event);
					}
				}
				else {
					if (-e.distY/h > settings.threshold || e.velocityY * e.distY/w * settings.sensitivity > 1) {
						event.type = 'swipeup';
						trigger(e.currentTarget, event);
					}
				}
			}
			else {
				if (e.distX > -e.distY) {
					if (e.distY/h > settings.threshold || e.velocityY * e.distY/w * settings.sensitivity > 1) {
						event.type = 'swipedown';
						trigger(e.currentTarget, event);
					}
				}
				else {
					if (-e.distX/w > settings.threshold || e.velocityX * e.distX/w * settings.sensitivity > 1) {
						event.type = 'swipeleft';
						trigger(e.currentTarget, event);
					}
				}
			}
		}
	
		function getData(node) {
			var data = jQuery.data(node, 'event_swipe');
			
			if (!data) {
				data = { count: 0 };
				jQuery.data(node, 'event_swipe', data);
			}
			
			return data;
		}
	
		jQuery.event.special.swipe =
		jQuery.event.special.swipeleft =
		jQuery.event.special.swiperight =
		jQuery.event.special.swipeup =
		jQuery.event.special.swipedown = {
			setup: function( data, namespaces, eventHandle ) {
				var data = getData(this);
	
				// If another swipe event is already setup, don't setup again.
				if (data.count++ > 0) { return; }
	
				add(this, 'moveend', moveend);
	
				return true;
			},
	
			teardown: function() {
				var data = getData(this);
	
				// If another swipe event is still setup, don't teardown.
				if (--data.count > 0) { return; }
	
				remove(this, 'moveend', moveend);
	
				return true;
			},
	
			settings: settings
		};
	});


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var $sliders = (0, _jquery2.default)('.slider');
	  var defaultOptions = {
	    // Custom options are set inline
	    dots: true,
	    arrows: false
	  };
	
	  $sliders.each(function () {
	    var $slider = (0, _jquery2.default)(this);
	    var inlineOptions = $slider.attr('data-slick');
	    var mergedOptions = inlineOptions ? (0, _objectAssign2.default)({}, defaultOptions, JSON.parse(inlineOptions)) : defaultOptions;
	    $slider.slick(mergedOptions);
	  });
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 8 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var $accordionHeaders = (0, _jquery2.default)('.accordion__header');
		$accordionHeaders.on('click', function (event) {
			event.preventDefault(); // prevent jumping around fix
	
			var $header = (0, _jquery2.default)(event.currentTarget);
	
			var fold = $header.closest(".accordion__fold");
			var id = $header.attr('for');
	
			var checkbox = (0, _jquery2.default)('#' + id);
			checkbox.is(':checked') ? checkbox.prop('checked', false) : checkbox.prop('checked', true);
			// $("#"+id).prop("checked",true);
			if (id) {}
			//console.log(id+"FO");
			//window.location.hash = id;			
	
			//quick fix for sliders not initializing in accordions
			setTimeout(function () {
				if (checkbox.is(':checked')) {
					var tScroll = fold.offset().top - (0, _jquery2.default)("header.header").height();
	
					(0, _jquery2.default)("body,html").stop().animate({ scrollTop: tScroll }, 500, 'swing');
				}
	
				(0, _jquery2.default)(window).trigger("resize");
				(0, _jquery2.default)(document).trigger("accordion_open", fold);
			}, 100);
		});
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var $window = (0, _jquery2.default)(window);
	  var $collapsible = (0, _jquery2.default)('.collapsing-header');
	  var oldScrollTop = 0;
	
	  var collide = function collide() {
	    // Don't do this on mobile
	    if ($window.innerWidth() < 768) return;
	
	    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	    var collapsibleHeight = $collapsible.outerHeight();
	
	    if (scrollTop > oldScrollTop && scrollTop > collapsibleHeight) {
	      // Scrolling down
	      $collapsible.css('margin-top', collapsibleHeight * -1);
	    } else {
	      // Scrolling up
	      $collapsible.css('margin-top', 0);
	    }
	
	    oldScrollTop = scrollTop;
	  };
	  $window.on('scroll', false, (0, _lodash2.default)(collide, 100));
	};
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 11 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	
	  var ua = navigator.userAgent.toLowerCase();
	
	  //console.log(ua);
	  var appName = navigator.appName.toLowerCase();
	
	  var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
	
	  var iOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream;
	
	  var isIeMobile = ua.indexOf("iemobile") > -1;
	
	  var isMStouch = ua.indexOf("touch") > -1 && ua.indexOf("trident") > -1;
	
	  var traceDiv = document.getElementById("trace");
	
	  var isGoogleChrome = ua.indexOf("chrome") > -1;
	
	  var isFirefox = ua.indexOf("firefox") > -1;
	
	  var isSafari = ua.indexOf("safari") > -1;
	
	  var IEVersion = detectIE();
	
	  var classStr = "";
	
	  if (IEVersion != null) {
	    classStr += " browser-ie-" + IEVersion;
	    classStr += " browser-ie";
	  }
	
	  if (iOS) {
	    classStr += " platform-ios";
	  }
	  if (isAndroid) {
	    classStr += " platform-android";
	  }
	
	  if (isIeMobile) {
	    classStr += " platform-iemobile";
	  }
	
	  if (isMStouch) {
	    classStr += " platform-iesurface";
	  }
	
	  if (isGoogleChrome) {
	    isSafari = false;
	    classStr += " browser-chrome";
	  }
	
	  if (isFirefox) {
	    classStr += " browser-firefox";
	  }
	  if (isSafari && !iOS) {
	    classStr += " browser-mac-safari";
	  }
	
	  if (isSafari && iOS) {
	    classStr += " browser-ios-safari";
	  }
	
	  document.documentElement.className += classStr;
	
	  function detectIE() {
	    var ua = window.navigator.userAgent;
	
	    // Test values; Uncomment to check result …
	
	    // IE 10
	    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	
	    // IE 11
	    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	
	    // Edge 12 (Spartan)
	    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	
	    // Edge 13
	    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
	
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	      // IE 10 or older => return version number
	      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	      // IE 11 => return version number
	      var rv = ua.indexOf('rv:');
	      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	
	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	      // Edge (IE 12+) => return version number
	      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }
	
	    // other browser
	    return null;
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(document).on("accordion_open", function () {
	    window.initGoogleMaps();
	});
	
	window.initGoogleMaps = function () {
	    var mapContainer = (0, _jquery2.default)(".map:not(.initialized)");
	
	    mapContainer.each(function (index, val) {
	        var me = (0, _jquery2.default)(this);
	        var accordion = me.closest(".accordion__fold");
	        if (accordion.length > 0) {
	            var radioInput = accordion.children("input[type='radio']");
	            if (!radioInput.is(":checked")) {
	                return;
	            }
	        }
	
	        me.addClass("initialized");
	
	        var mapdata = (0, _jquery2.default)(val).closest(".mapdata");
	
	        var coords = mapdata.attr('data-coords').split(',');
	        coords = {
	            lat: parseFloat(coords[0]),
	            lng: parseFloat(coords[1])
	        };
	
	        var place = mapdata.attr('data-place');
	        var address = mapdata.attr('data-address').split(',');
	
	        var map = new google.maps.Map(val, {
	            zoom: 15,
	            center: coords
	        });
	
	        var marker = new google.maps.Marker({
	            position: coords,
	            map: map
	        });
	
	        var infoContent = '<div>' + '<strong>' + place + '</strong>' + '<p>' + address[0] + '</p>' + address[1] + "," + address[2] + '</p>' + '</div>';
	        var infowindow = new google.maps.InfoWindow({
	            content: infoContent
	        });
	        // infowindow.open(map, marker);
	
	        marker.addListener('click', function () {
	            infowindow.open(map, marker);
	        });
	    });
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerSearchbtn;
	var headerSearchInput;
	
	var formSearch;
	var formSearchInput;
	var formSearchBtn;
	var formResultsCount;
	var formLoadMoreBtn;
	var sResults;
	var pIndex = 0;
	
	(0, _jquery2.default)(document).ready(function () {
		headerSearchbtn = (0, _jquery2.default)("header .search-box__button");
		headerSearchInput = (0, _jquery2.default)("header .search-box__input");
	
		headerSearchbtn.on("click", headerSearchClick);
		headerSearchInput.on("keydown", headerKeyHandler);
	
		formSearch = (0, _jquery2.default)(".search-form");
	
		if (formSearch.length == 0) {
			return;
		}
	
		formSearchBtn = formSearch.find(".search-btn");
		formSearchInput = formSearch.find(".search-txt");
	
		formResultsCount = formSearch.find(".page-search-results-count");
		formLoadMoreBtn = formSearch.find(".loadmore-btn");
	
		formLoadMoreBtn.on("click", formLoadMoreClick);
	
		formSearchBtn.on("click", formSearchClick);
		formSearchInput.on("keydown", keyHandler);
		sResults = formSearch.find(".page-search-results");
	
		if (formSearchInput.val() != "") {
			runSearch();
		}
	});
	
	function headerKeyHandler(event) {
		if (event.keyCode == 13) {
			event.preventDefault();
			headerSearchClick();
		}
	}
	
	function headerSearchClick(event) {
		if (event != undefined) {
			event.preventDefault();
		}
	
		var sVal = headerSearchInput.val();
		console.log(headerSearchInput, "headerSearchClick");
		if (sVal == "") {
			sVal = headerSearchInput.eq(1).val();
		}
		var url = window.location.protocol + "//" + window.location.host + headerSearchbtn.attr("data-searchpage") + "/?s=" + sVal;
		window.location.href = url;
	}
	
	function keyHandler(event) {
		if (event.keyCode == 13) {
			event.preventDefault();
			runSearch(event);
		}
	}
	function formLoadMoreClick(event) {
		pIndex++;
		//sResults.html("");
		event.preventDefault();
		runSearch();
	}
	function formSearchClick(event) {
		pIndex = 0;
		sResults.html("");
		event.preventDefault();
		runSearch();
	}
	
	function runSearch() {
	
		formLoadMoreBtn.addClass("hidden");
	
		var val = formSearchInput.val();
		var url = formSearchInput.attr("data-search-api") + val;
	
		var data = {};
		data.id = val;
		data.pageIndex = pIndex;
		data.timestamp = new Date().getTime();
	
		//sResults.html("")
	
		_jquery2.default.ajax({
			dataType: "json",
			url: url,
			data: data,
			method: "GET",
			success: onSearchData
	
		});
	}
	
	function onSearchData(results) {
		console.log(results);
	
		if (results.HasMoreResults) {
			formLoadMoreBtn.removeClass("hidden");
		}
		formResultsCount.html(results.TotalResults);
	
		if (results.Items.length == 0) {}
	
		var items = results.Items;
	
		var buff = sResults.html();
	
		for (var i = 0; i < items.length; i++) {
			var item = items[i];
			buff += "<a href='" + item.Url + "' class='search-result-item' target='_blank'>";
			buff += "<h3>" + item.Title + "</h3>";
			buff += "<p>" + item.Description + "</p>";
	
			buff += "</a>";
		}
	
		sResults.html(buff);
	}

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	var pIndex = 0;
	var blogApp;
	
	var loadMoreBtn;
	$(document).ready(function () {
		blogApp = $(".blog-item-container");
		if (blogApp.length == 0) {
			return;
		}
	
		loadMoreBtn = $(".blog-load-more-btn");
	
		loadMoreBtn.on("click", loadMoreClick);
	});
	
	function loadMoreClick(event) {
		event.preventDefault();
		pIndex++;
		var guid = blogApp.attr("data-guid");
		var url = blogApp.attr("data-blog-api-url");
	
		loadMoreBtn.addClass("hidden");
	
		//console.log(url + guid);
	
		$.ajax({
			dataType: "json",
			url: url,
			data: { guid: guid, pageIndex: pIndex },
			success: onServerData
	
		});
	}
	
	function onServerData(results) {
	
		blogApp.find(".row").eq(0).append(results.Html);
	
		if (results.ShowButton) {
			loadMoreBtn.removeClass("hidden");
		}
	}

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	//due to time and budget more elegant solution doesn't exist....
	
	$(document).ready(function () {
	
	  //ios flexbox issue fix.
	
	  $(window).on("resize", onResize);
	  onResize();
	});
	
	function onResize(event) {
	  setTimeout(function () {
	    afterResize();
	  }, 150);
	}
	
	function afterResize() {
	  $(".leaf--left").each(function () {
	
	    var leftLeaf = $(this);
	    var rightLeaf = leftLeaf.closest(".leaves").find(".leaf--right");
	    leftLeaf.css("min-height", "");
	    rightLeaf.css("min-height", "");
	
	    if (leftLeaf.offset().top == rightLeaf.offset().top) {
	      var h = Math.max(leftLeaf.parent().height(), rightLeaf.parent().height());
	      leftLeaf.css("min-height", h);
	      rightLeaf.css("min-height", h);
	    }
	  });
	
	  $(".navigation__list.nav_sub li a").css("min-height", "");
	
	  var ulItems = $(".navigation__list.nav_sub");
	
	  ulItems.each(function () {
	    var ulItem = $(this);
	    var sorter = {};
	    var liItems = ulItem.find("li");
	    liItems.each(function () {
	      var liItem = $(this);
	      var bounds = liItem[0].getBoundingClientRect();
	      //console.log(bounds);
	      if (sorter[bounds.top] == undefined) {
	        sorter[bounds.top] = [];
	      }
	      sorter[bounds.top].push(liItem);
	    });
	    for (var index in sorter) {
	      var list = sorter[index];
	      var maxH = 0;
	      for (var i = 0; i < list.length; i++) {
	        maxH = Math.max(maxH, list[i].outerHeight());
	      }
	      for (var i = 0; i < list.length; i++) {
	        //maxH = Math.max(maxH,list[i].height());
	        var diff = maxH - list[i].height();
	        list[i].find('> a').css("min-height", maxH);
	      }
	    }
	  });
	}

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var pommi = $('.tifigs-pommfritt');
	  var navi = $('.navigation__level.default > .navigation__list');
	  var links = navi.find('>li');
	  var active = navi.find('>li.active');
	  var aColor = "black";
	  //console.log("hoi");
	
	  links.on('mouseenter', function (e) {
	    var target = $(e.currentTarget);
	    navi.addClass("hovering");
	    //links.css('color', 'black');
	    //target.css('color', "black");
	    freese(e.target.clientWidth, target.offset().left - navi.offset().left);
	  });
	
	  if (active.length) {
	    var activeItems = navi.find('>li.active');
	    //activeItems.css('color', aColor)
	    var activeLeft = activeItems.offset().left - navi.offset().left;
	    var activeWidth = active[0].clientWidth;
	    freese(activeWidth, activeLeft);
	
	    // Zruggfreese
	    links.on('mouseleave', function (e) {
	      //links.css('color', 'black');
	      //active.css('color', aColor);
	      freese(activeWidth, activeLeft);
	      navi.removeClass("hovering");
	    });
	  } else {
	    links.on('mouseleave', function (e) {
	      var target = $(e.currentTarget);
	      //links.css('color', 'black');
	      freese(0, target.offset().left - navi.offset().left);
	      navi.removeClass("hovering");
	    });
	  }
	
	  function freese(width, left) {
	    pommi.css({
	      width: width,
	      transform: 'translate3d(' + left + 'px, 0, 0)'
	    });
	  }
	};
	
	;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// app.js